angular.module('impactx.budget').controller('BudgetTemplateUsageListCtrl', BudgetTemplateUsageListCtrl);
BudgetTemplateUsageListCtrl.$inject = ['$routeParams', 'selectedListItems'];

function BudgetTemplateUsageListCtrl($routeParams, selectedListItems) {

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditBudget'
        }
    ];
    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/budget/templates/btpusagelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/budgetTemplate/listUsages',
        id: "budgetusagelist",
        valuesInteger: [{name: "BUDTEMPLATE_Id", value: $routeParams.id}]
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "budget/" + selectedListItems.getFirstSelectedId();
    }
}